import RatingCriteria from './RatingCriteria'

export default RatingCriteria
